import React from 'react';
import PropTypes from 'prop-types';
import SchoolName from './SchoolName';
import Mailer from './Mailer';
import Phone from './PhoneNumber';

const Contsacts = ({ t, email, setValue, phone, schoolTitle }) => (
  <>
    <SchoolName t={t} setValue={setValue} schoolTitle={schoolTitle} />
    <Mailer t={t} setValue={setValue} email={email} />
    <Phone t={t} setValue={setValue} phone={phone} />
  </>
);

Contsacts.propTypes = {
  setValue: PropTypes.func,
  t: PropTypes.func,
  email: PropTypes.string,
  phone: PropTypes.string,
  schoolTitle: PropTypes.string,
};

Contsacts.defaultProps = {
  setValue: () => {},
  t: () => {},
  email: '',
  phone: '',
  schoolTitle: '',
};

export default Contsacts;
